import { CameraEventType, Cartesian3, Ion, JulianDate, ShadowMode, Viewer, BoundingSphere, SceneMode, MapMode2D, Entity, KmlDataSource } from "cesium";
import { CreateToolbar } from "./services/createToolbar";
import { TreeTileModel } from "./services/treeTileModel";
import { FlyLocation } from "./services/flyToLocation";
import { ContextMenu } from "./services/contextMenu";
import { MapWheater } from "./services/mapWeather";
import { LabelPoint } from "./services/mapDistance/labelPoint";
// import { DataPropeties } from "./services/dataProperties";
import { FlyCamera } from "./services/flyCamera";
import { FooterViewer } from "./services/footerView";
import Compass from "./utils/compass/compass";
import { SceneManager } from "./services/sceneManager";
import { TileModel } from "./class/tileModel";
import { createUUID, flyToVietNam, handleTreeModelTile, hasAnyValidInput } from "./utils/utils";
import { InputDataPrimitive, zoomMinMax } from "./services/styleElement";
import { InputIsolate, InputSetColor } from "./class/styleElement";
import { ToolbarOptions } from "./interfaces/toolBar.interface";
import { IDPUViewer, SelectedObjectInfo } from "./interfaces/dpuViewer.interface";
import { IInputObjs3DTile } from "./interfaces/sceneManager.interface";

import { TaskColorByObj } from "./interfaces/styleElement.interface";
import { IViewSave, IViewSave2D, loadViewCamera, loadViewCamera2D, saveViewCamera, saveViewCamera2D } from "./services/utilsView";
import { ExtentionToolBar, IOptionExtension } from "./services/extensionToolbar";
import { IInputSetMap, IObjInputMap } from "./interfaces/map.interface";
import { DataPropeties } from "./services/newDataProperties";
import { LayerModelNew } from "./services/layerModelNew";
import { getMessage } from '../src/language';
import pLimit from 'p-limit';

import GlobalStore from "./services/globarStore/globarStore";



// Định nghĩa Enum cho loại hành động
interface SortModel {
    id: string
    arrange: number
}

export class DPUViewer implements IDPUViewer {
    viewer: Viewer | undefined;
    private _containerId: string;
    private _token: string = ""

    private _treeTileModel?: TreeTileModel
    private _flyLocation?: FlyLocation
    private _contextMenu?: ContextMenu
    private _mapWeather?: MapWheater
    private _labelPoint?: LabelPoint
    private _dataProperties?: DataPropeties
    private _flyCamera?: FlyCamera
    private _sceneManager?: SceneManager
    private _inputObjectPrimtive?: InputDataPrimitive
    private _createToolBar?: CreateToolbar
    private _layerModel?: LayerModelNew

    optionToolbar?: ToolbarOptions = {
        treeTileModel: true,
        homeLocation: true,
        yourLocation: true,
        mapWeather: true,
        measure: true,
        point: true,
        labelPoint: false,
        dataProperties: true,
        flyCamera: false,
        treeViews: true,
        isNoneMap: false,
        issuePoint: false,
        flyToVietNam: true,
        requestRenderMode: true,
        map2DMode: false,
        footerView: true,
        compass: true

    };
    private _treeViews: any = []
    constructor(containerId: string, token: string, inputOptionToolbar?: ToolbarOptions) {
        this._containerId = containerId; // Gán giá trị containerId
        this.optionToolbar = { ...this.optionToolbar, ...inputOptionToolbar }

        // const tokenCesium = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJiMTBjMzY3Mi0zZGYzLTRiZjAtOGYxYS1kNDAzNTg5MGEzNTEiLCJpZCI6MjM1NDA1LCJpYXQiOjE3MjM5Nzc2OTV9.MyuJ80_a8hm5919QUzpeJHUGZQtrhCR_WdoXQK_31xY";// Gán giá trị token

        const tokenCesium = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1MDg1ZjI1ZS01YzI0LTQ5ZjctOWFhOS1kYWM2NjY3NDkxMWUiLCJpZCI6MzIyNTczLCJpYXQiOjE3NTI4MDc1OTB9.zqWd94izcxlV4icr74vnOgZFum75JZtEswpgxdMbFfU"

        // const tokenCesium = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI5YWEyYzM4NS1kY2U4LTRmN2EtYjYzMC01MTU4NWViNTA2NTAiLCJpZCI6MjM1NDA1LCJpYXQiOjE3MjQwMjkyNDB9.HkMo8BdNRKI-uQXyiRO7UfxBAiXLYvEtbWKPufOuuFo"

        this._initCesiumViewer(tokenCesium, token).catch((error: any) => {
            console.error('Error initializing Cesium Viewer:', error);
        });
    }


    //#region initCesiumViewer
    /**
     * Hàm khởi tạo view Cesium
     */
    private _initCesiumViewer = async (tokenCesium: string, token: string): Promise<Viewer> => {
        if (this.viewer) {
            return this.viewer
        }

        if (tokenCesium != null) {
            Ion.defaultAccessToken = tokenCesium;
        }
        this._token = token

        this.viewer = new Viewer(this._containerId, {
            // terrain: Terrain.fromWorldTerrain(),
            contextOptions: {
                webgl: {
                    alpha: true,
                    antialias: true,  // Bật chế độ khử răng cưa
                    premultipliedAlpha: false,// xử lý màu blend,
                    preserveDrawingBuffer: true,
                }
            },
            requestRenderMode: this.optionToolbar?.requestRenderMode,
            sceneMode: this.optionToolbar?.map2DMode ? SceneMode.SCENE2D : SceneMode.SCENE3D,
            mapMode2D: this.optionToolbar?.map2DMode ? undefined : MapMode2D.INFINITE_SCROLL,
            orderIndependentTranslucency: false,
            animation: false,
            homeButton: false,
            baseLayerPicker: false,
            infoBox: false,
            sceneModePicker: false,
            timeline: false,
            navigationInstructionsInitiallyVisible: false,
            navigationHelpButton: false,
            fullscreenButton: false,
            geocoder: false,// nut zoom

            shadows: false, // tắt đổ bóng
            terrainShadows: ShadowMode.DISABLED, // tắt độ bóng trên địa hình

        });

        this.viewer.scene.renderError.addEventListener((scene, error) => {
            console.error("Cesium renderError caught:", error);
            if (error?.message?.includes("near must be greater") && this.viewer) {
                const container = document.getElementById(this._containerId);
                if (container && container.clientWidth > 0 && container.clientHeight > 0) {
                    this.viewer.camera.flyHome(0);
                }
            }
        });


        // this.viewer.scene.verticalExaggerationRelativeHeight = 0;

        // Thay đổi chức năng xoay trục (tilt) từ Ctrl + chuột trái sang chuột phải
        this.viewer.scene.screenSpaceCameraController.tiltEventTypes = [
            CameraEventType.RIGHT_DRAG, // Sử dụng chuột phải để xoay trục
            CameraEventType.PINCH,
            CameraEventType.MIDDLE_DRAG
        ];
        this.viewer.scene.screenSpaceCameraController.zoomEventTypes = [
            CameraEventType.WHEEL,        // Sử dụng lăn chuột để zoom
            CameraEventType.PINCH        // Sử dụng pinch (trên thiết bị di động) để zoom
        ];


        // Thiết lập thời gian cụ thể
        var julianDate: any = JulianDate.fromDate(new Date(2024, 1, 1, 8)); // 30 tháng 9 2024, 12:00 trưa

        // Cập nhật thời gian trong CesiumJS
        this.viewer.clock.currentTime = julianDate;
        this.viewer.scene.globe.enableLighting = true; // Bật hiệu ứng ánh sáng theo thời gian

        GlobalStore.getInstance(this._containerId)

        this._inputObjectPrimtive = new InputDataPrimitive(this.viewer)

        this._flyLocation = new FlyLocation(this._containerId, this.viewer, this._treeViews);
        this._contextMenu = new ContextMenu(this._containerId, this.viewer, this._inputObjectPrimtive)
        this._mapWeather = new MapWheater(this._containerId, this.viewer, this.optionToolbar?.isNoneMap)
        this._labelPoint = new LabelPoint(this._containerId, this.viewer)
        // this._dataProperties = new DataPropeties(this._containerId, this.viewer)
        this._dataProperties = new DataPropeties(this._containerId, this.viewer, this._token)

        this._flyCamera = new FlyCamera(this._containerId, this.viewer)
        if (this.optionToolbar?.footerView) {
            new FooterViewer(this._containerId, this.viewer)
        }
        if (this.optionToolbar?.compass) {

            new Compass(this.viewer)
        }
        this._sceneManager = new SceneManager(this._containerId, this.viewer, this._token, this._inputObjectPrimtive!);
        this._treeTileModel = new TreeTileModel(this._containerId, this.viewer, this._treeViews, this._sceneManager)
        this._layerModel = new LayerModelNew(this._containerId, this.viewer, this._token, this._sceneManager, this._contextMenu)
        // this.treeFolderModel = new TreeFolder(this.containerId, this.viewer, this.treeFolders, this.sortList)
        if (this._inputObjectPrimtive && this._contextMenu) {
            this._inputObjectPrimtive.setContextMenu(this._contextMenu)
        }
        if (this._contextMenu && this._layerModel) {
            this._contextMenu.layerModel = this._layerModel
        }
        if (this._dataProperties) {
            this._dataProperties.inputObjPrimitive = this._inputObjectPrimtive
            this._layerModel.inputDataPrimitive = this._inputObjectPrimtive
        }
        // this.createToolbar()
        //Bay đến việtnam
        this.flyToVietNam()
        this._createToolBar = new CreateToolbar(this._containerId, this.viewer, {
            treeTileModel: this._treeTileModel,
            treeLayerModel: this._layerModel,
            flyToLcation: this._flyLocation,
            contextMenu: this._contextMenu,
            labelPoint: this._labelPoint,
            dataProperties: this._dataProperties,
            flyCamera: this._flyCamera,
            mapWeather: this._mapWeather
            // treeViews: this.treeViews
        }, this.optionToolbar)
        //Thêm class cho Container ID
        const containerID = document.querySelector(`#${this._containerId}`)
        if (containerID) {
            containerID.className = 'DPU-container-view'
        }


        return this.viewer

    }



    //#region  Dark theme
    /**
     * Hàm set Dark/Light theme cho viewer
        * @param {boolean} dark true: dark theme, false: light theme
     */
    setDarkTheme = (dark: boolean) => {
        const containerId = document.querySelector(`#${this._containerId}`)
        if (containerId) {
            if (dark) {
                containerId.classList.add("darkmode")
            } else {
                containerId.classList.remove("darkmode")

            }
        }
    }
    //#region destroyView
    /**
     * Hàm hủy view
     */
    destroyView = () => {
        if (this.viewer) {
            if (!this.viewer.isDestroyed()) {
                this.viewer.destroy();
            }
            this.viewer = undefined;
        }

        const containerId = document.querySelector(`#${this._containerId}`);
        if (containerId) {
            // Lặp qua tất cả các con và xóa
            while (containerId.firstChild) {
                const child = containerId.firstChild as HTMLElement;

                try {
                    // In thông tin phần tử đang xử lý
                    // console.log(`Removing child element:`, child);

                    // Clone phần tử để loại bỏ sự kiện
                    const clonedChild = child.cloneNode(true) as HTMLElement;
                    containerId.replaceChild(clonedChild, child);

                    // Xóa phần tử
                    containerId.removeChild(clonedChild);
                } catch (error) {
                    // Báo lỗi nếu có vấn đề với phần tử
                    console.error(`Error while removing element:`, child, error);
                }
            }
            console.log("All child elements removed successfully.");
        } else {
            console.error(`Container not found: ${this._containerId}`);
        }
    }


    //#region setLocationHome
    setLocationHome = (inputLocation: {
        longitude: number;
        latitude: number;
        height?: number;
        angle?: number;
        pitch?: number;
        duration?: number
    }) => {
        this._flyLocation!.setLocationHome(inputLocation);
    }

    //#region flyToHomeLocation

    /**
     * Hàm xử lý hành động bay đến vị trí công trường  
     */
    flyToHomeLocation = async () => {

        return this.enqueue(async () => {
            if (this._treeViews.length > 0) {
                this._flyLocation!.flyToHomeLocation()
            } else {
                this.flyToVietNam()
            }
        })
    }


    //#region flyToLocation
    /**
      * Hàm bay đến vị trí mong muốn riêng
      *  @param {number} longitude kinh độ
      * @param {number} latitude  vĩ độ
      * @param {number} height  độ cao
      * @param {number} duration  thời gian bay
      */
    flyToLocation = (longitude: number, latitude: number, height: number = 1000, duration: number = 2) => {
        this._flyLocation!.flyToLocation(longitude, latitude, height, duration)
    }

    //#region load3DTileUrl

    /**
     * Tải không đồng bộ một 3D tile từ URL được chỉ định và tạo một `TileModel` tương ứng.     *
     * @param url - URL của 3D tile cần tải.
     * @param name - (Tùy chọn) Tên của tile. Nếu không được cung cấp, một UUID sẽ được tạo.
     * @param urlConnect - (Tùy chọn) URL để kết nối thêm dữ liệu đối tượng đầu vào.
     * @param inputObjs - (Tùy chọn) Các đối tượng đầu vào bổ sung cho 3D tile.
     * 
     * @returns Một promise trả về một `TileModel` nếu tile được tải thành công, hoặc `undefined` nếu tải thất bại.
     
     */
    load3DTileUrl = async (url: string, name?: string, urlConnect?: string, inputObjs?: IInputObjs3DTile): Promise<TileModel | undefined> => {
        return this.enqueue(async () => {
            // Đợi cho Promise trả về kết quả
            const tileset = await this._sceneManager!.load3DTileUrl(url, inputObjs);

            if (tileset) {
                const newTree = new TileModel(
                    {
                        id: createUUID(),
                        isShow: true,
                        loadType: 0,
                        contentType: '3dtile',
                        name: name || createUUID(),  // Đảm bảo nếu name không có, tạo một UUID mới
                        url: url
                    },
                    this._sceneManager!
                );

                newTree.tileset = tileset;
                newTree.setOriginalModelMatrix() // Lưu lại ma trận gốc của mô hình
                if (inputObjs) {
                    newTree.inputObjs = inputObjs
                }

                this._treeViews.push(newTree);
                //Lưu trữ Data Primite cho contextMenu
                if (url) {
                    await this._inputObjectPrimtive!.setObjDataPrimitive(url)
                }
                //Set objId nếu như có render màu, zoom

                if (urlConnect) {
                    await this._inputObjectPrimtive!.setInputObjDataPrimitive(urlConnect, url)
                    // Hợp nhất dữ liệu mới vào `this.listKeyMapObject`
                    this._layerModel!.listKeyMapObject = {
                        ... this._layerModel!.listKeyMapObject,
                        ...this._inputObjectPrimtive!.listKeyMapObject, // Dữ liệu hiện tại
                        // Dữ liệu mới
                    };
                    this._layerModel!.renderTreeLayerModel()
                }

                this._sceneManager!.setPositionModel(newTree.tileset, inputObjs)
                if (!newTree.isShow) {
                    newTree.isShow = false
                }
                this._treeTileModel?.renderTreeView();

                return newTree;  // Trả về newTree sau khi tất cả đã hoàn thành.
            }
            return undefined
        });
    };


    private queue: Promise<any> = Promise.resolve();  // Thay vì Promise<void>, sử dụng Promise<any> để linh hoạt

    // Hàm thêm tác vụ vào hàng đợi
    private enqueue<T>(task: () => Promise<T>): Promise<T> {
        this.queue = this.queue
            .then(() => task()) // Đảm bảo rằng các tác vụ được xử lý tuần tự
            .catch(err => {
                console.log(err);
                // throw err; // Ném lỗi để các tác vụ sau đó có thể xử lý lỗi
            });
        return this.queue as Promise<T>;  // Ép kiểu trả về Promise<T>
    }
    private _totalModelLoad: number = 0;  // Biến lưu trữ tổng số mô hình đã tải
    private _firstChildLoad: boolean = false;

    //#region  loadTree3DTileUrl
    //Load tree theo kiểu mới
    loadTree3DTileUrl = async (url: string, obj?: any): Promise<TileModel[]> => {
        const tempListTree: TileModel[] = []; // Mảng chứa các TileModel
        let setInputObjDataPrimitive: any;
        let treeViewsJson: any;
        this._firstChildLoad = false;
        let loadFromDefault = false
        await this.enqueue(async () => {
            if (!obj) {
                const response = await fetch(url);
                const jsonString = await response.text();
                treeViewsJson = JSON.parse(jsonString);
            } else {
                treeViewsJson = obj;
            }

            // Sắp xếp lại treeViewsJson dựa vào parentID để đảm bảo parent luôn đứng trước child
            function sortByParentID(flatArr: any[]): any[] {
                const idToNode: Record<string, any> = {};
                const idToChildren: Record<string, any[]> = {};
                const roots: any[] = [];
                flatArr.forEach(item => {
                    if (item.isLoadDefault) {
                        loadFromDefault = true
                    }
                    idToNode[item.id] = item;
                    if (item.parentID == null) {
                        roots.push(item);
                    } else {
                        if (!idToChildren[item.parentID]) idToChildren[item.parentID] = [];
                        idToChildren[item.parentID].push(item);
                    }
                });
                // Tìm folder cha lớn nhất có isLoadDefault=true
                let topDefaultFolders = roots.filter(item => item.isFolder && item.isLoadDefault);
                // Loại khỏi roots để tránh lặp lại
                let otherRoots = roots.filter(item => !(item.isFolder && item.isLoadDefault));
                // BFS duyệt từ root, đảm bảo parent trước child
                const result: any[] = [];
                // Đầu tiên là parentID=null
                const queue: any[] = [...otherRoots, ...topDefaultFolders];
                while (queue.length > 0) {
                    const node = queue.shift();
                    result.push(node);
                    if (idToChildren[node.id]) {
                        queue.push(...idToChildren[node.id]);
                    }
                }
                return result;
            }
            let sortedTreeViewsJson = sortByParentID(treeViewsJson);

            // Đệ quy gán isLoadDefault cho tất cả con/cháu nếu parent là folder và isLoadDefault=true
            function setDefaultForChildren(nodes: any[], parentId: string) {
                nodes.forEach(child => {
                    if (child.parentID === parentId) {
                        child.isLoadDefault = true;
                        if (child.isFolder) {
                            setDefaultForChildren(nodes, child.id);
                        }
                    }
                });
            }
            sortedTreeViewsJson.forEach(parent => {
                if (parent.isFolder && parent.isLoadDefault) {
                    setDefaultForChildren(sortedTreeViewsJson, parent.id);
                }
            });

            // Sort lại theo yêu cầu: parentID=null lên đầu, tiếp theo là isFolder=true, tiếp theo là isFolder=false nhưng có isLoadDefault=true, cuối cùng là các node còn lại
            sortedTreeViewsJson = sortedTreeViewsJson.sort((a, b) => {
                // parentID=null lên đầu
                if (a.parentID == null && b.parentID != null) return -1;
                if (a.parentID != null && b.parentID == null) return 1;
                // isFolder=true lên tiếp
                if (a.isFolder && !b.isFolder) return -1;
                if (!a.isFolder && b.isFolder) return 1;
                // isFolder=false nhưng có isLoadDefault=true lên tiếp
                if (!a.isFolder && a.isLoadDefault && !b.isFolder && !b.isLoadDefault) return -1;
                if (!b.isFolder && b.isLoadDefault && !a.isFolder && !a.isLoadDefault) return 1;
                return 0;
            });


            sortedTreeViewsJson.forEach(parent => {
                if (parent.isFolder && parent.isLoadDefault) {
                    setDefaultForChildren(sortedTreeViewsJson, parent.id);
                }
            });


            this._totalModelLoad = sortedTreeViewsJson.filter((item: any) => item.parentID != null && item.isFolder !== true).length;

            const limit = pLimit(15);
            let totalModel = 0;
            const getTileSetPromises: Promise<any>[] = [];
            for (const view of sortedTreeViewsJson) {

                const newView = new TileModel(
                    {
                        id: view.id,
                        name: view.name,
                        parentID: view.parentID,
                        url: view.url,
                        translateId: view.translateId,
                        contentType: view.contentType,
                        loadType: view.loadType,
                        isShow: view.isShow,
                        fileType: view.fileType,
                        isFolder: view.isFolder,
                        isLoadDefault: view.isLoadDefault,
                        boundingBoxDefault: view.boundingBoxDefault,
                    },
                    this._sceneManager!
                );
                newView.inputObjectPrimtive = this._inputObjectPrimtive
                newView.inputObjs = {
                    x: view?.x || undefined,
                    y: view?.y || undefined,
                    z: view?.z || undefined,
                    height: view?.height || undefined,
                    latitude: view?.latitude || undefined,
                    longitude: view?.longitude || undefined,
                    maximumScreen: view?.maximumScreen,
                    sizePointCloud: view?.sizePointCloud ?? 2,

                };


                // Nếu là child, cố gắng gán inputObjs từ parent
                const findParent = tempListTree.find((item: any) => item.id === view.parentID);
                if (findParent) {
                    const _currentInput = { ...newView.inputObjs };
                    newView.inputObjs = { ...findParent.inputObjs, ..._currentInput };

                    // if (view?.maximumScreen) {
                    //     newView.inputObjs = {
                    //         ...newView.inputObjs,
                    //         maximumScreen: view.maximumScreen
                    //     };
                    // }

                }

                this._treeViews.push(newView);
                tempListTree.push(newView);

                if (newView.isFolder && !this._firstChildLoad && newView.isLoadDefault && newView.boundingBoxDefault) {


                    const bb = newView.boundingBoxDefault
                    const bbMax = new Cartesian3(bb.max.x!, bb.max.y!, bb.max.z!);
                    const bbMin = new Cartesian3(bb.min.x!, bb.min.y!, bb.min.z!);

                    // Tạo BoundingSphere từ min và max
                    const center = new Cartesian3(
                        (bbMin.x + bbMax.x) / 2,
                        (bbMin.y + bbMax.y) / 2,
                        (bbMin.z + bbMax.z) / 2
                    );

                    const radius = Cartesian3.distance(bbMin, bbMax) / 2;
                    const boundingSphere = new BoundingSphere(center, radius);
                    this._sceneManager?.cameraFlyToBouding(boundingSphere);

                    this._firstChildLoad = true

                }


                if (!newView.isFolder) {
                    const promise = limit(() => newView.getTileSet().then(() => {
                        totalModel++;

                        this._renderLoadModel({
                            containerId: this._containerId,
                            totalModel: this._totalModelLoad,
                            currentModel: totalModel
                        });

                        handleTreeModelTile(tempListTree);

                        if (loadFromDefault && !newView.isLoadDefault && !this._firstChildLoad) {

                            const findItemLoadDefault = tempListTree.find((item) => !item.isFolder && item.isLoadDefault);
                            // console.log('vo item zoom to', findItemLoadDefault);
                            if (findItemLoadDefault && findItemLoadDefault.tileset && newView.isShow) {
                                findItemLoadDefault.zoomTo()
                                this._firstChildLoad = true

                            }

                        }

                        if (newView.parentID && newView.contentType !== "kmz") {
                            this._layerModel!.treeLayerModels.push({
                                name: newView.name,
                                objectId: createUUID(),
                                parent: newView.parentID,
                                isLoadData: false,
                                isFolder: true,

                                primitiveName: newView.primitiveName,
                                level: undefined
                            });
                        }


                    }));
                    getTileSetPromises.push(promise);
                }


                if (view.url) {
                    await this._inputObjectPrimtive!.setObjDataPrimitive(view.url);
                }
                if (view.urlConnect) {
                    setInputObjDataPrimitive = await this._inputObjectPrimtive!.setInputObjDataPrimitive(view.urlConnect, view.url);
                }

                if (view.contentType !== "kmz") {
                    if (view.isFolder) {
                        this._layerModel!.treeLayerModels.push({
                            name: view.name,
                            objectId: view.id,
                            parent: view.parentID,
                            primitiveName: view.translateId ? newView.primitiveName : setInputObjDataPrimitive?.data?.folder,
                            isLoadData: false,
                            level: (view.parentID === undefined || view.parentID === null) ? 0 : undefined,
                            isFolder: true
                        });
                    }
                    // if (!view.isFolder) {
                    //     if (view.parentID) {
                    //         this._layerModel!.treeLayerModels.push({
                    //             name: "",
                    //             objectId: createUUID(),
                    //             parent: view.id,
                    //             isLoadData: false,
                    //             primitiveName: setInputObjDataPrimitive?.data?.folder,
                    //             level: undefined
                    //         });
                    //     }
                    // }
                    // this._layerModel!.listKeyMapObject = {
                    //     ... this._layerModel!.listKeyMapObject,
                    //     ...this._inputObjectPrimtive!.listKeyMapObject,
                    // };

                    // this._layerModel!.renderTreeLayerModel();
                }


            }

            await Promise.all(getTileSetPromises);
            this._layerModel!.listKeyMapObject = {
                ... this._layerModel!.listKeyMapObject,
                ...this._inputObjectPrimtive!.listKeyMapObject,
            };

            this._layerModel!.renderTreeLayerModel();
            this._treeTileModel?.renderTreeView();

        });
        return tempListTree;
    };

    private _containerLoad: HTMLElement | undefined
    private _renderLoadModel = ({ containerId, totalModel, currentModel }: { containerId: string, totalModel: number, currentModel: number }) => {
        const ctnId = document.getElementById(containerId);
        if (!ctnId) return;

        if (!this._containerLoad) {
            this._containerLoad = document.createElement("div");
            this._containerLoad.className = "dpu-waiting-load-model";

            ctnId.appendChild(this._containerLoad);
        }

        this._containerLoad.innerText = `${getMessage('loading-model')}: ${currentModel}/${totalModel}`;

        if (currentModel === totalModel) {
            // Xóa phần tử sau 1 giây
            setTimeout(() => {
                if (this._containerLoad && this._containerLoad.parentNode) {
                    this._containerLoad.parentNode.removeChild(this._containerLoad);
                    this._containerLoad = undefined; // Đặt lại biến để có thể tạo lại lần sau
                }
            }, 1000); // 1000 milliseconds = 1 second
        }
    }


    //#region   getModelTreeUrl
    private sortList: SortModel[] = []
    private arrange: number = 1
    //Load tree theo kiểu củ
    getModelTreeUrl = async (url: string, maximumScreen: number = 16): Promise<TileModel[]> => {
        const tempListTree: TileModel[] = []; // Mảng chứa các TileModel        
        this.enqueue(async () => {
            const newId = createUUID()
            const newItem: SortModel = {
                id: newId,
                arrange: this.arrange++
            }
            this.sortList.push(newItem)
            const response = await fetch(url);

            if (!response.ok) throw new Error('Failed to fetch tree folder data');

            const jsonString = await response.text();
            const treeFolderData = JSON.parse(jsonString); // Phân tích JSON
            const splits = url.split("/");
            const result = splits.slice(0, splits.length - 2).join("/");


            const flatFolders = this._flattenFolderTree(treeFolderData)


            for (const view of flatFolders) {
                let newUrl
                if (view.url.includes("Tileset.json")) {
                    newUrl = `${result}/${view.url}`
                }
                const newView = new TileModel(
                    {
                        id: view.id,
                        name: view.name,
                        parentID: view.parentID,
                        url: newUrl,
                        translateId: view.translateId,
                        contentType: view.contentType,
                        loadType: view.loadType,
                        isShow: view.isShow,
                        fileType: view.fileType,
                        isFolder: view.isFolder
                    },
                    this._sceneManager!
                );
                newView.inputObjs = {
                    x: view?.x || undefined,
                    y: view?.y || undefined,
                    z: view?.z || undefined,
                    height: view?.height || undefined,
                    latitude: view?.latitude || undefined,
                    longitude: view?.longitude || undefined,
                    maximumScreen: view?.maximumScreen ?? maximumScreen,
                    sizePointCloud: view?.sizePointCloud ?? 2,
                }
                if (!newView.isFolder) {
                    // Chờ đợi kết quả từ `getTileSet` trước khi tiếp tục
                    await newView.getTileSet();

                }

                const findParent = tempListTree.find((item: any) => item.id === view.parentID)
                if (findParent) {

                    if (!hasAnyValidInput(view)) {
                        newView.inputObjs = findParent?.inputObjs
                    }
                    if (view?.maximumScreen) {
                        newView.inputObjs = {
                            ...newView.inputObjs,
                            maximumScreen: view.maximumScreen,
                            sizePointCloud: view.sizePointCloud ?? 2,
                        };
                    }

                }

                this._treeViews.push(newView);

                tempListTree.push(newView);
                //Lưu trữ Data Primite cho contextMenu
                if (view.url) {
                    await this._inputObjectPrimtive!.setObjDataPrimitive(view.url)
                }
                //Set objId nếu như có render màu, zoom
                if (view.urlConnect) {
                    await this._inputObjectPrimtive!.setInputObjDataPrimitive(view.urlConnect, view.url)
                }
                handleTreeModelTile(tempListTree)


            }
            // handleTreeModelTile(tempListTree)

            // this._treeTileModel?.renderTreeView();
            return tempListTree;  // Trả về mảng đã được xây dựng

        });
        return tempListTree
    };


    //Hàm đệ quy trải phẳng
    private _flattenFolderTree = (data: any, parentID?: string, flatFolders: any[] = [], baseUrl?: string) => {
        // Tạo đối tượng thư mục mới từ dữ liệu JSON và thêm các trường mới
        const tileSet = {
            id: createUUID(),  // Tạo ID ngẫu nhiên
            name: data.Name || '',
            parentID: parentID,
            url: baseUrl,
            dataId: undefined,  // Tạo dataId ngẫu nhiên
            contentType: '3dtile',  // Có thể thay đổi nếu cần
            loadType: 0,  // Có thể thay đổi nếu cần
            isShow: data.IsShow,

        };

        // Tạo URL cho thư mục hiện tại: "cha/con"
        let currentUrl = baseUrl ? `${baseUrl}/${data.Name}` : data.Name;

        // Nếu thư mục này không có con, thêm .json vào URL
        if (!data.Childrens || data.Childrens.length === 0) {
            currentUrl += '/Tileset.json';
        }

        // Cập nhật URL của thư mục hiện tại
        tileSet.url = currentUrl;

        // Thêm thư mục vào mảng flatFolders
        flatFolders.push(tileSet);

        // Duyệt qua các thư mục con và tiếp tục trải phẳng
        if (data.Childrens && data.Childrens.length > 0) {
            data.Childrens.forEach((child: any) => {
                // Đệ quy gọi hàm flattenFolderTree để xử lý các thư mục con
                this._flattenFolderTree(child, tileSet.id, flatFolders, currentUrl);
            });
        }

        return flatFolders;
    };




    /**
     * Hàm load file KMZ từ URL
     * @param {string} url URL của file KMZ cần tải.
     * @param {string} name Tên của file KMZ để hiển thị trong TreeView.
     * @returns {Promise<TileModel>} Trả về đối tượng `TileModel` mới được tạo sau khi tải xong file KMZ.
     */

    //#region loadKMZ
    // Hàm loadKMZ
    loadKMZ = async (url: string, name: string, inputObjs?: IInputObjs3DTile): Promise<TileModel | undefined> => {
        // Đảm bảo rằng task loadKmz đã hoàn thành trước khi tiếp tục
        const tileset = await this.enqueue(async () => {
            return this._sceneManager!.loadKmz(url, inputObjs);  // Đợi đến khi loadKmz hoàn thành
        });
        if (tileset) {
            const newTree = new TileModel(
                {
                    id: createUUID(),
                    isShow: true,
                    loadType: 0,
                    contentType: 'kmz',
                    name: name,
                    url: url,
                },
                this._sceneManager!
            );

            newTree.tileset = tileset;

            if (inputObjs) {
                newTree.inputObjs = inputObjs
            }

            this._treeViews.push(newTree);
            this._treeTileModel?.renderTreeView();
            //Set objId nếu như có render màu, zoom
            // await setObjDataPrimitive(url, this.viewer)
            return newTree;  // Trả về newTree sau khi tất cả các tác vụ hoàn thành
        }
        return undefined
    };

    //#region  load3DTileById

    /**
     * Hàm tải không đồng bộ một 3D tile theo ID và thêm vào TreeView.
     * 
     * @param id - ID duy nhất của 3D tile cần tải.
     * @param name - (Tùy chọn) Tên được gán cho tile đã tải. Nếu không cung cấp, sẽ tạo UUID.
     * @param urlConnect - (Tùy chọn) URL kết nối để tải thêm dữ liệu.
     * @param inputObjs - (Tùy chọn) Các tham số đầu vào bổ sung để tải 3D tile.
     * 
     * @returns Một promise trả về một đối tượng `TileModel` đại diện cho 3D tile đã tải, 
     *          hoặc `undefined` nếu không tải được.
     */
    load3DTileById = async (id: string, name?: string, urlConnect?: string, inputObjs?: IInputObjs3DTile): Promise<TileModel | undefined> => {
        return this.enqueue(async () => {
            const resultLoadId = await this._sceneManager?.load3DTileById(id, urlConnect, inputObjs);
            const tileSet = resultLoadId?.tileSet;
            if (tileSet) {
                const newTree = new TileModel(
                    {
                        id: createUUID(), // Tạo UUID mới cho TileModel
                        isShow: true, // Hiển thị TileModel
                        url: resultLoadId.url, // URL của tile
                        name: name || createUUID(), // Tên hoặc UUID nếu không có tên
                        loadType: 1, // Loại tải
                        translateId: id, // ID dịch
                        contentType: '3dtile', // Kiểu nội dung
                    },
                    this._sceneManager!
                );

                newTree.tileset = tileSet; // Gán tileset cho TileModel
                newTree.setOriginalModelMatrix() // Lưu lại ma trận gốc của mô hình

                this._treeViews.push(newTree); // Thêm vào danh sách TreeView
                this._treeTileModel?.renderTreeView(); // Render lại TreeView

                this._layerModel!.treeLayerModels.push({
                    name: name,
                    objectId: name + "-" + id + "-first",
                    parent: null,
                    primitiveName: resultLoadId.dataConnect?.data?.folder,
                    isLoadData: false,
                })


                this._layerModel!.treeLayerModels.push({
                    name: "",
                    objectId: createUUID(),
                    parent: name + "-" + id + "-first",
                    isLoadData: false,
                    primitiveName: resultLoadId.dataConnect?.data?.folder
                })

                // Hợp nhất dữ liệu mới vào `this.listKeyMapObject`
                this._layerModel!.listKeyMapObject = {
                    ... this._layerModel!.listKeyMapObject,
                    ...this._inputObjectPrimtive!.listKeyMapObject, // Dữ liệu hiện tại
                    // Dữ liệu mới
                };
                this._sceneManager!.setPositionModel(newTree.tileset, inputObjs)
                if (!newTree.isShow) {
                    newTree.isShow = false
                }
                this._layerModel!.renderTreeLayerModel()
                return newTree; // Trả về TileModel mới sau khi hoàn thành
            }
            return undefined; // Trả về undefined nếu không tải được
        });
    };

    //#region loadPathCameraKMZ

    /**
    * Hàm tải và hiển thị đường đi camera từ file KMZ
    * @param {string} url URL của file KMZ chứa dữ liệu đường đi camera.
    * @param {string} [name] Tên của camera hoặc dữ liệu đường đi (tùy chọn).
    */
    loadPathCameraKMZ = (url: string, name?: string) => {

        this._flyCamera!.loadFileKmzFromUrl(url);
    }

    //#region loadLabelPointFromUrl
    /**
     * Tải và tạo các điểm nhãn từ một URL.
     *
     * @param url - Đường dẫn URL chứa dữ liệu điểm nhãn.
     * @param loadFormJson - (Tùy chọn) Xác định xem có tải dữ liệu từ JSON hay không. Mặc định là `false`.
     * @param dataJson - (Tùy chọn) Dữ liệu JSON để sử dụng nếu `loadFormJson` là `true`. Mặc định là chuỗi rỗng.
     * @param isShow - (Tùy chọn) Xác định xem có hiển thị các điểm nhãn sau khi tải hay không. Mặc định là `false`.
     */
    loadLabelPointFromUrl = (url: string, loadFormJson: boolean = false, dataJson: any = "", isShow: boolean = false) => {
        if (!loadFormJson) {
            this._labelPoint!.createLabelPointFromUrl(url, loadFormJson, dataJson, isShow)
        } else {
            this._labelPoint!.requestJsonRenderTree(dataJson, isShow)
        }
    }


    /**
    * Hàm Zoom đến Tile
    * @param {any} tile Tile để zoom tới
    */

    zoomToTile = (tile: any) => {
        this._sceneManager!.zoomTo(tile)
    }

    //#region setColor
    setColor = async (inputObjs: InputSetColor[]) => {
        return this.enqueue(async () => {
            if (this._contextMenu) {
                this._contextMenu.listPicked = [];
            }
            this._inputObjectPrimtive!.setColorObjs(inputObjs)
        })
    }
    //#region resetDefaultColor
    resetDefaultColor = () => {
        this._inputObjectPrimtive!.resetDefaultColor()
    }

    //#resetAllDefaultColor
    resetAllDefaultColor = async () => {
        this._inputObjectPrimtive!.resetAllDefaultColor()
    }

    //#region resetAllColor
    resetAllColor = async () => {
        return this.enqueue(async () => {
            this._inputObjectPrimtive!.resetAllColor()
        })

    }

    //#region setColorByTask
    setColorByTask = (
        completeObj: TaskColorByObj,
        inProgressObj: TaskColorByObj,
        reColor: [number, number, number, number] | string = [240, 240, 240, 1]) => {
        return this.enqueue(async () => {
            this._inputObjectPrimtive!.setColorByTask(completeObj, inProgressObj, reColor)
        })
    }


    //#region isolateObjs
    isolateObjs = async (inputObjs: InputIsolate[]) => {
        return this.enqueue(async () => {
            this._inputObjectPrimtive!.isolateObjs(inputObjs)
        })
    }


    //#region resetAll isolateObjs
    resetAllDefaultIsolate = () => {
        this._inputObjectPrimtive!.resetAllDefaultIsolate()
    }

    //#region reset Default isolateObjs
    resetDefaultIsolate = async () => {
        return this.enqueue(async () => {

            this._inputObjectPrimtive!.resetDefaultIsolate()
        })

    }

    //#region resetAllColor
    resetAllIsolate = async () => {
        return this.enqueue(async () => {
            this._inputObjectPrimtive!.resetAllIsolate()

        })
    }
    //
    clearObjDataPrimitive = async () => {
        return this.enqueue(async () => {
            this._inputObjectPrimtive!.clearObjDataPrimitive()
        })
    }


    //#region ZoomToObjs
    zoomToObjects = async (inputObjs: any[]) => {
        this.enqueue(async () => {
            await zoomMinMax(this.viewer, inputObjs, this._inputObjectPrimtive!.ObjDataPrimitive)

        })
    }

    getObjectIdsBySelect = (callback?: (selectedIds: SelectedObjectInfo[]) => void): SelectedObjectInfo[] | undefined => {
        if (callback) {
            this._contextMenu?.setOnSelectionChangedCallback(callback);
        }
        return this._contextMenu?.getObjsIdsPicked();
    }

    //#region saveViewCamera
    saveViewCamera = () => {
        if (!this.viewer) return
        let viewSave: IViewSave | IViewSave2D
        if (this.optionToolbar?.map2DMode) {
            viewSave = saveViewCamera2D(this.viewer)
        } else {
            viewSave = saveViewCamera(this.viewer)
        }
        return viewSave
    }

    //#region loadViewCamera
    loadViewCamera(viewSave: IViewSave | IViewSave2D): void {
        if (!this.viewer) return
        if (this.optionToolbar?.map2DMode) {
            loadViewCamera2D(this.viewer, viewSave as IViewSave2D)
        } else {

            loadViewCamera(this.viewer, viewSave as IViewSave)
        }
    }


    //#region Extention ToolBar
    createExtentionToolBar = (callback: (data: any) => void, option: IOptionExtension) => {
        if (!this.viewer) return

        const newBtnToolbar = new ExtentionToolBar(this._containerId, this.viewer, callback, option, this._dataProperties)

        newBtnToolbar.setClosedCallback((status: boolean) => {

            newBtnToolbar.triggerChange({
                action: `Closed`,
                status: status
            })
        })
        return newBtnToolbar
    }

    //#region flyToVietNam 
    flyToVietNam = () => {
        this.enqueue(async () => {
            if (this.optionToolbar!.flyToVietNam) {
                if (!this.viewer) return

                const container = document.getElementById(this._containerId);
                if (container && (container.clientWidth === 0 || container.clientHeight === 0)) {
                    setTimeout(() => this.flyToVietNam(), 200);
                    return;
                }

                flyToVietNam(this.viewer)
            }

        })
    }
    //#region getOptionMap 
    getOptionMap = (): IObjInputMap => {
        const obj = this._mapWeather?.getObjMap();

        if (!obj) {
            throw new Error("Map weather object is undefined");
        }

        return obj;
    }

    //#region setOptionMap 
    setOptionMap = (objMap: IObjInputMap) => {
        if (objMap) {
            this.enqueue(async () => {
                this._mapWeather!.setObjMap(objMap)
            })
        }

    }


    //#region setInputMap
    setInputMap = (inputMap: IInputSetMap) => {
        this.enqueue(async () => {
            this._mapWeather!.setInfoMap(inputMap)
        })
    }

    //#region issuePoint
    issuePoint = (callback?: (data: any) => void) => {
        if (this._createToolBar && this._createToolBar.issuePoint) {
            const issuePoint = this._createToolBar.issuePoint
            issuePoint.callback = callback;

            // issuePoint.setClosedCallback((status: boolean) => {
            //     console.log("123123123");
            //     if (!status) {
            //         issuePoint.triggerChange({
            //             action: "Closed",
            //             status: status
            //         })
            //     }
            // })

            return issuePoint
        }
        return undefined
    }
    //#region callBackGetHiddenTreeViews

    callBackGetHiddenTreeViews = (callback: (data: any) => void) => {
        if (this._treeTileModel) {
            this._treeTileModel.callBackSaveHiddenTreeViews = callback
            if (this._treeTileModel && this._treeTileModel.dialog) {
                this._treeTileModel.renderFooter();
                setTimeout(() => {
                    this._treeTileModel?.dialog?.calFooterHeight()
                }, 50)

            }
        }

    }
    //#region callBackLabelPoint
    callBackLabelPoint = (callback: (data: any) => void, toggleBtn: boolean = false, isDev: boolean = false) => {
        if (this._labelPoint) {
            this._labelPoint.callBackLabelPoint = callback
            if (this._labelPoint && this._labelPoint.dialog) {
                if (isDev) {
                    this._labelPoint.isDev = true
                }
                if (toggleBtn) {
                    this._labelPoint.isToggleBtnGroup = true
                    this._labelPoint.renderBtnGroup();
                }
            }
        }
    }
    //#region getHidenTreeViews
    getHidenTreeViews = () => {
        return this._treeTileModel?.getTreeView()
    }

    //#region callBackMap
    callBackMap = (callback: (data: any) => void) => {
        if (this._mapWeather) {
            this._mapWeather.callbackMap = callback;

            this._mapWeather.renderFooter()
        }
    }

    //#region callBackLocationPick


    //#region handleZoomEarth 
    handleZoomEarth = (zoom: boolean) => {
        if (this._sceneManager) {
            this._sceneManager.handleZoomEarth(zoom)
        }
    }

    //#region loadImageryLayerUrl
    onChangeMap = (layer: number, mapUrls?: { id: string, url: string }[]) => {
        if (this._sceneManager) {
            this._sceneManager.onChangeMap(layer, mapUrls)
        }
    }

    //#region flyToYourLocation
    flyToYourLocation = (zDistance?: number, duration?: number) => {
        if (this._sceneManager) {
            this._sceneManager.flyToYourLocation(zDistance, duration)
        }
    }
    //#region locationPickPin
    locationPickPin = (callback?: (data: { longitude: number; latitude: number } | null) => void) => {
        if (this._flyLocation) {
            this._flyLocation.locationPickPin(callback)
        }
    }

    //#region removePickPin
    removePickPin = () => {
        if (this._flyLocation) {
            this._flyLocation.removePickPin()
        }
    }

    //#region enableKmzClickPicking
    enableKmzClickPicking = (callback: (entity: Entity | undefined, dataSource: KmlDataSource | undefined) => void) => {
        if (this._sceneManager) {
            this._sceneManager.enableKmzClickPicking(callback);
        }
    }

    //#region disableKmzClickPicking
    disableKmzClickPicking = () => {
        if (this._sceneManager) {
            this._sceneManager.disableKmzClickPicking();
        }
    }
}


